import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu} from "antd";
import {useTranslation} from "react-i18next";
import {Pages} from "../../../AppRouter";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useModal} from "../../../core/context/ModalContext";
import ReportTemplateCreateEditForm from "../ReportTemplateCreateEditForm";
import ReportTemplateSorter from "../ReportTemplateSorter";

export default function ReportTemplateRowMenu({row})
{
    const {t} = useTranslation();
    const {refreshDataGrid} = useDataGrid()
    const {openModal, closeModal} = useModal()

    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    <Menu.Item key={'edit'}>
                        <a
                            onClick={() => {
                                openModal(
                                    t('Edit Report Template'),
                                    <ReportTemplateCreateEditForm reportTemplateId={row.id} />,
                                    () => {}
                                )
                            }}
                        >
                            {t('Edit')}
                        </a>
                    </Menu.Item>
                    <Menu.Item key={'sort'}>
                        <a
                            onClick={() => {
                                openModal(
                                    t(`Sort Report Template (${row?.requestType?.name})`),
                                    <ReportTemplateSorter
                                        reportTemplateId={row.id}
                                        reqTypeId={row?.requestType?.id}
                                        onSaved={() => {
                                            closeModal()
                                        }}
                                    />,
                                    () => {}
                                )
                            }}
                        >
                            {t('Sort')}
                        </a>
                    </Menu.Item>
                    <Menu.Item key={'delete'}>
                        <a
                            onClick={async () => {
                                const res = await ApiService.ReportTemplate.DeleteTemplate(row.id);
                                if(res.success) {
                                    refreshDataGrid()
                                }
                            }}
                        >
                            {t('Delete')}
                        </a>
                    </Menu.Item>
                </Menu>
            </RowMenu>
        </>
    )
}
